export default __webpack_public_path__ + "static/media/Annual-Secretarial-Compliance-Report-2026.3a0d5ed8.pdf";